import { createSelector } from 'reselect';

export const profilesAccessor = state => state.profiles;

export const profilesSelector = createSelector(profilesAccessor, profiles => profiles);